import { IconUsers } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { Cluster as ClusterType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { ClusterView } from './View'
import { messages } from './messages'

import { useConditions } from '../useConditions'
import { ClusterEditor } from './Editor'

type ClusterConditionProps = {
  name: string
}

export function Cluster(props: ClusterConditionProps) {
  const { name } = props
  const drawerState = useDrawerState()
  const { formatMessage: i18n } = useIntl()
  const { form } = useFormStateContext()

  useConditions({
    name,
    onEdit: drawerState.show,
    label: i18n(messages.title),
    icon: <IconUsers />,
  })

  const clusterCondition: ClusterType | undefined = useWatch({ form, name })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (config: ClusterType | undefined) =>
    form.setValue(name, config)

  return (
    <>
      <ClusterView
        config={clusterCondition}
        onEdit={drawerState.show}
        onRemove={handleRemove}
      />

      <ClusterEditor
        values={clusterCondition}
        state={drawerState}
        onSave={handleSave}
      />
    </>
  )
}
